export const ADMIN_EMAIL = 'balgaly@gmail.com';

export const CRITERIA = [
    { id: "songQuality", label: "Song Quality", weight: 0.4, description: "How good is the composition, melody, and lyrics of the song" },
    { id: "staging", label: "Staging", weight: 0.25, description: "How interesting and amazing the visual presentation is on stage" },
    { id: "vocalQuality", label: "Vocal Quality", weight: 0.35, description: "How talented and skilled the performer is vocally" }
];

export const initialContests = [
    {
        id: "melo2025",
        name: "Melodifestivalen 2025",
        contestants: [
            { id: 1, name: "John Lundvik – 'Voice of the Silent'" },
            { id: 2, name: "Dolly Style – 'Yihaa'" },
            { id: 3, name: "Greczula – 'Believe Me'" },
            { id: 4, name: "Klara Hammarström – 'On and On and On'" },
            { id: 5, name: "Scarlet – 'Sweet N' Psycho'" },
            { id: 6, name: "Erika Segerstedt – 'Show Me What love Is'" },
            { id: 7, name: "Maja Ivarsoon – 'Kamikaze Life'" },
            { id: 8, name: "Meira Omar – 'Hush Hush'" },
            { id: 9, name: "Måns Zelmerlöw – 'Revolution'" },
            { id: 10, name: "Saga Ludvigsson – 'Hate You So Much'" },
            { id: 11, name: "Annika Wickihalder – 'Life Again'" },
            { id: 12, name: "Kaj – 'Bara bada bastu'" }
        ]
    },
    {
        id: "euro2025",
        name: "Eurovision 2025",
        contestants: [
            { id: 1, name: "Sweden" },
            { id: 2, name: "United Kingdom" },
            { id: 3, name: "France" },
            { id: 4, name: "Germany" },
            { id: 5, name: "Italy" }
        ]
    },
    {
        id: "euro2025sf1",
        name: "Eurovision 2025 Semi Final 1",
        contestants: [
            { id: 1, name: "VÆB – RÓA", country: "Iceland" },
            { id: 2, name: "Justyna Steczkowska – GAJA", country: "Poland" },
            { id: 3, name: "Klemen – How Much Time Do We Have Left", country: "Slovenia" },
            { id: 4, name: "Tommy Cash – Espresso Macchiato", country: "Estonia" },
            { id: 5, name: "Ziferblat – Bird of Pray", country: "Ukraine" },
            { id: 6, name: "KAJ – Bara Bada Bastu", country: "Sweden" },
            { id: 7, name: "NAPA – Deslocado", country: "Portugal" },
            { id: 8, name: "Kyle Alessandro – Lighter", country: "Norway" },
            { id: 9, name: "Red Sebastian – Strobe Lights", country: "Belgium" },
            { id: 10, name: "Mamagama – Run With U", country: "Azerbaijan" },
            { id: 11, name: "Gabry Ponte – Tutta L’Italia", country: "San Marino" },
            { id: 12, name: "Shkodra Elektronike – Zjerm", country: "Albania" },
            { id: 13, name: "Claude – C’est La Vie", country: "Netherlands" },
            { id: 14, name: "Marko Bošnjak – Poison Cake", country: "Croatia" },
            { id: 15, name: "Theo Evan – Shh", country: "Cyprus" }
        ]
    },
    {
        id: "euro2025final",
        name: "Eurovision 2025",
        contestants: [
            { id: 1, order: 1, country: "Norway", name: "Kyle Alessandro – Lighter" },
            { id: 2, order: 2, country: "Luxembourg", name: "Laura Thorn – La Poupée Monte Le Son" },
            { id: 3, order: 3, country: "Estonia", name: "Tommy Cash – Espresso Macchiato" },
            { id: 4, order: 4, country: "Israel", name: "Yuval Raphael – New Day Will Rise" },
            { id: 5, order: 5, country: "Lithuania", name: "Katarsis – Tavo Akys" },
            { id: 6, order: 6, country: "Spain", name: "Melody – Esa Diva" },
            { id: 7, order: 7, country: "Ukraine", name: "Ziferblat – Bird of Pray" },
            { id: 8, order: 8, country: "United Kingdom", name: "Remember Monday – What The Hell Just Happened?" },
            { id: 9, order: 9, country: "Austria", name: "JJ – Wasted Love" },
            { id: 10, order: 10, country: "Iceland", name: "VÆB – RÓA" },
            { id: 11, order: 11, country: "Latvia", name: "Tautumeitas – Bur Man Laimi" },
            { id: 12, order: 12, country: "Netherlands", name: "Claude – C’est La Vie" },
            { id: 13, order: 13, country: "Finland", name: "Erika Vikman – Ich Komme" },
            { id: 14, order: 14, country: "Italy", name: "Lucio Corsi – Volevo Essere un Duro" },
            { id: 15, order: 15, country: "Poland", name: "Justyna Steczkowska – Gaja" },
            { id: 16, order: 16, country: "Germany", name: "Abor & Tynna – Baller" },
            { id: 17, order: 17, country: "Greece", name: "Klavdia – Asteromata" },
            { id: 18, order: 18, country: "Armenia", name: "Parg – Survivor" },
            { id: 19, order: 19, country: "Switzerland", name: "Zoë Më – Voyage" },
            { id: 20, order: 20, country: "Malta", name: "Miriana Conte – Serving" },
            { id: 21, order: 21, country: "Portugal", name: "Napa – Deslocado" },
            { id: 22, order: 22, country: "Denmark", name: "Sissal – Hallucination" },
            { id: 23, order: 23, country: "Sweden", name: "KAJ – Bara Bada Bastu" },
            { id: 24, order: 24, country: "France", name: "Louane – Maman" },
            { id: 25, order: 25, country: "San Marino", name: "Gabry Ponte – Tutta l’Italia" },
            { id: 26, order: 26, country: "Albania", name: "Shkodra Elektronike – Zjerm" }
        ]
    },
    {
        id: "euro2026sf1",
        name: "Eurovision 2026 Semi-Final 1",
        contestants: [
            { id: 1, country: "Belgium", name: "Essyla - Dancing on the Ice" },
            { id: 2, country: "Croatia", name: "Lelek - Andromeda" },
            { id: 3, country: "Estonia", name: "Vanilla Ninja - Too Epic To Be True" },
            { id: 4, country: "Finland", name: "Linda Lampenius & Pete Parkkonen - Liekinheitin" },
            { id: 5, country: "Georgia", name: "Bzikebi - On Replay" },
            { id: 6, country: "Greece", name: "Akylas - Ferto" },
            { id: 7, country: "Israel", name: "Noam Bettan - Michelle" },
            { id: 8, country: "Lithuania", name: "Lion Ceccah - Solo quiero mas" },
            { id: 9, country: "Moldova", name: "Satoshi - Viva, Moldova" },
            { id: 10, country: "Montenegro", name: "Tamara Zivkovic - Nova zora" },
            { id: 11, country: "Poland", name: "Alicja - Pray" },
            { id: 12, country: "Portugal", name: "Bandidos do Cante - Rosa" },
            { id: 13, country: "San Marino", name: "Senhit - Superstar" },
            { id: 14, country: "Serbia", name: "Lavina - Kraj mene" },
            { id: 15, country: "Sweden", name: "Felicia - My System" }
        ]
    },
    {
        id: "euro2026sf2",
        name: "Eurovision 2026 Semi-Final 2",
        contestants: [
            { id: 1,  order: 1,  country: "Bulgaria",       name: "Dara - Bangaranga" },
            { id: 2,  order: 2,  country: "Azerbaijan",     name: "Jiva - Just Go" },
            { id: 3,  order: 3,  country: "Romania",        name: "Alexandra Căpitănescu - Choke Me" },
            { id: 4,  order: 4,  country: "Luxembourg",     name: "Eva Marija - Mother Nature" },
            { id: 5,  order: 5,  country: "Czechia",        name: "Daniel Žižka - Crossroads" },
            { id: 6,  order: 6,  country: "France",         name: "Monroe - Regarde !" },
            { id: 7,  order: 7,  country: "Armenia",        name: "Simón - Paloma Rumba" },
            { id: 8,  order: 8,  country: "Switzerland",    name: "Veronica Fusaro - Alice" },
            { id: 9,  order: 9,  country: "Cyprus",         name: "Antigoni - Jalla" },
            { id: 10, order: 10, country: "Austria",        name: "Cosmó - Tanzschein" },
            { id: 11, order: 11, country: "Latvia",         name: "Atvara - Ēnā" },
            { id: 12, order: 12, country: "Denmark",        name: "Søren Torpegaard Lund - Før vi går hjem" },
            { id: 13, order: 13, country: "Australia",      name: "Delta Goodrem - Eclipse" },
            { id: 14, order: 14, country: "Ukraine",        name: "Leléka - Ridnym" },
            { id: 15, order: 15, country: "United Kingdom", name: "Look Mum No Computer - Eins, Zwei, Drei" },
            { id: 16, order: 16, country: "Albania",        name: "Alis - Nân" },
            { id: 17, order: 17, country: "Malta",          name: "Aidan - Bella" },
            { id: 18, order: 18, country: "Norway",         name: "Jonas Lovv - Ya ya ya" }
        ]
    },
    {
        id: "euro2026final",
        name: "Eurovision 2026 Grand Final",
        contestants: [
            { id: 1,  order: 1,  country: "Denmark",        name: "Søren Torpegaard Lund - Før Vi Går Hjem" },
            { id: 2,  order: 2,  country: "Germany",        name: "Sarah Engels - Fire" },
            { id: 3,  order: 3,  country: "Israel",         name: "Noam Bettan - Michelle" },
            { id: 4,  order: 4,  country: "Belgium",        name: "ESSYLA - Dancing on the Ice" },
            { id: 5,  order: 5,  country: "Albania",        name: "Alis - Nân" },
            { id: 6,  order: 6,  country: "Greece",         name: "Akylas - Ferto" },
            { id: 7,  order: 7,  country: "Ukraine",        name: "LELÉKA - Ridnym" },
            { id: 8,  order: 8,  country: "Australia",      name: "Delta Goodrem - Eclipse" },
            { id: 9,  order: 9,  country: "Serbia",         name: "LAVINA - Kraj Mene" },
            { id: 10, order: 10, country: "Malta",          name: "AIDAN - Bella" },
            { id: 11, order: 11, country: "Czechia",        name: "Daniel Zizka - CROSSROADS" },
            { id: 12, order: 12, country: "Bulgaria",       name: "DARA - Bangaranga" },
            { id: 13, order: 13, country: "Croatia",        name: "LELEK - Andromeda" },
            { id: 14, order: 14, country: "United Kingdom", name: "LOOK MUM NO COMPUTER - Eins, Zwei, Drei" },
            { id: 15, order: 15, country: "France",         name: "Monroe - Regarde !" },
            { id: 16, order: 16, country: "Moldova",        name: "Satoshi - Viva, Moldova!" },
            { id: 17, order: 17, country: "Finland",        name: "Linda Lampenius x Pete Parkkonen - Liekinheitin" },
            { id: 18, order: 18, country: "Poland",         name: "ALICJA - Pray" },
            { id: 19, order: 19, country: "Lithuania",      name: "Lion Ceccah - Sólo Quiero Más" },
            { id: 20, order: 20, country: "Sweden",         name: "FELICIA - My System" },
            { id: 21, order: 21, country: "Cyprus",         name: "Antigoni - JALLA" },
            { id: 22, order: 22, country: "Italy",          name: "Sal Da Vinci - Per Sempre Sì" },
            { id: 23, order: 23, country: "Norway",         name: "JONAS LOVV - YA YA YA" },
            { id: 24, order: 24, country: "Romania",        name: "Alexandra Căpitănescu - Choke Me" },
            { id: 25, order: 25, country: "Austria",        name: "COSMÓ - Tanzschein" }
        ]
    }
];

export const COUNTRY_CODES = {
  'Iceland': 'IS', 'Poland': 'PL', 'Slovenia': 'SI', 'Estonia': 'EE', 'Ukraine': 'UA',
  'Sweden': 'SE', 'Portugal': 'PT', 'Norway': 'NO', 'Belgium': 'BE', 'Azerbaijan': 'AZ',
  'San Marino': 'SM', 'Albania': 'AL', 'Netherlands': 'NL', 'Croatia': 'HR', 'Cyprus': 'CY',
  'Australia': 'AU', 'Montenegro': 'ME', 'Ireland': 'IE', 'Latvia': 'LV', 'Armenia': 'AM',
  'Austria': 'AT', 'United Kingdom': 'GB', 'Greece': 'GR', 'Lithuania': 'LT', 'Malta': 'MT',
  'Georgia': 'GE', 'France': 'FR', 'Denmark': 'DK', 'Czechia': 'CZ', 'Luxembourg': 'LU',
  'Israel': 'IL', 'Germany': 'DE', 'Serbia': 'RS', 'Finland': 'FI', 'Spain': 'ES',
  'Switzerland': 'CH', 'Italy': 'IT', 'Moldova': 'MD', 'Bulgaria': 'BG', 'Romania': 'RO',
};

// Removed 8 least-used emojis based on Firestore reaction counts (SF1+SF2 data):
// star(0), sparkle_heart(0), kiss(0), party(0), rocket(0), ok_hand(0), eyes(0), moai(0)
export const EMOJI_REACTIONS = [
  { id: 'fire', emoji: '\u{1F525}', label: 'React with fire' },
  { id: 'heart_eyes', emoji: '\u{1F60D}', label: 'React with heart eyes' },
  { id: 'mind_blown', emoji: '\u{1F92F}', label: 'React with mind blown' },
  { id: 'mic', emoji: '\u{1F3A4}', label: 'React with microphone' },
  { id: 'pride', emoji: '\u{1F3F3}️‍\u{1F308}', label: 'React with pride flag' },
  { id: 'clap', emoji: '\u{1F44F}', label: 'React with clap' },
  { id: 'dance', emoji: '\u{1F483}', label: 'React with dance' },
  { id: 'rofl', emoji: '\u{1F923}', label: 'React with ROFL' },
  { id: 'crown', emoji: '\u{1F451}', label: 'React with crown' },
  { id: 'meh', emoji: '\u{1F610}', label: 'React with meh' },
  { id: 'thinking', emoji: '\u{1F914}', label: 'React with thinking' },
  { id: 'grimace', emoji: '\u{1F62C}', label: 'React with grimace' },
  { id: 'sleeping', emoji: '\u{1F634}', label: 'React with sleeping' },
  { id: 'thumbs_down', emoji: '\u{1F44E}', label: 'React with thumbs down' },
  { id: 'puke', emoji: '\u{1F92E}', label: 'React with puke' },
  { id: 'skull', emoji: '\u{1F480}', label: 'React with skull' },
];
